import clsx from 'clsx';

export function Card({ children, className = '', header, footer, sub }) {
  return (
    <div className={clsx('card', className)}>
      {header ? (
        <div className="card-h">
          <div className="flex-1">
            <h3 className="text-[14.5px] font-bold tracking-tight">{header}</h3>
            {sub ? <div className="text-xs text-ink-3 mt-0.5">{sub}</div> : null}
          </div>
        </div>
      ) : null}
      <div className="card-b">{children}</div>
      {footer ? <div className="card-h border-b-0 border-t">{footer}</div> : null}
    </div>
  );
}
